import React from 'react';
import { Provider } from 'react-redux';
import configureStore from './configureStore';
import LeftNavComponent from './LeftNav.component';

// store that holds the complete state of app.
const store = configureStore();
const LeftNav = props => /*#__PURE__*/React.createElement(Provider, {
  store: store
}, /*#__PURE__*/React.createElement(LeftNavComponent, props));
export default LeftNav;